import { render, staticRenderFns } from "./UsersDetails.vue?vue&type=template&id=9e2e21a2&"
import script from "./UsersDetails.vue?vue&type=script&lang=ts&"
export * from "./UsersDetails.vue?vue&type=script&lang=ts&"
import style0 from "./UsersDetails.vue?vue&type=style&index=0&id=9e2e21a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports